export const salseTerm = [
  {
    key: 0,
    value: 'Total'
  },
  {
    key: 1,
    value: 'Today'
  },
  {
    key: 2,
    value: 'Month'
  }
];
